import React from 'react'

function Gallery() {
  return (
    <section class="gallery-section-two p-0" id="memory">
        <div class="carsoul-outer">
            <div class="gallery-carousel-two owl-carousel owl-theme">
                
                <div class="gallery-block-two">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image">
                        <a href="page-gallery.html"><img src="images/resource/gallery2-1.jpg" alt="" /></a>
                        </figure>
                    </div>
                    <div class="info-box">
                        <h4 class="title"><a href="#">Photography</a></h4>
                        <div class="text">With expert photogrpaher</div>
                    </div>
                    </div>
                </div>
                <div class="gallery-block-two">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image">
                        <a href="page-gallery.html"><img src="images/resource/gallery2-2.jpg" alt="" /></a>
                        </figure>
                    </div>
                    <div class="info-box">
                        <h4 class="title"><a href="#">Photography</a></h4>
                        <div class="text">With expert photogrpaher</div>
                    </div>
                    </div>
                </div>
                <div class="gallery-block-two">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image">
                        <a href="page-gallery.html"><img src="images/resource/gallery2-3.jpg" alt="" /></a>
                        </figure>
                    </div>
                    <div class="info-box">
                        <h4 class="title"><a href="#">Photography</a></h4>
                        <div class="text">With expert photogrpaher</div>
                    </div>
                    </div>
                </div>
                <div class="gallery-block-two">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image">
                        <a href="page-gallery.html"><img src="images/resource/gallery2-4.jpg" alt="" /></a>
                        </figure>
                    </div>
                    <div class="info-box">
                        <h4 class="title"><a href="#">Photography</a></h4>
                        <div class="text">With expert photogrpaher</div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Gallery